import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';
import typography from './typography';

injectGlobal(`
  @media (min-width: 1400px) {
    .container {
      max-width: 1300px;
    }
  }
  @media (min-width: 1600px) {
    .container {
      max-width: 1500px;
    }
  }
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 500;
    font-size: 18px;
    color: ${colors.body};
    font-family: ${typography.SansSerif};
  }
  strong, b {
    font-weight: 700;
  }
  a {
    color: ${colors.brand1};
    text-decoration: none;
    &:hover {
      color: ${colors.brand1Light};
      text-decoration: none;
    }
  }
  .btn {
    background-color: ${colors.brand2};
    font-weight: 700;
    color: ${colors.body};
    letter-spacing: 1.2px;
    text-transform: uppercase;
    padding: 10px 40px 10px 15px;
    transition: all .3s ease-out;
    background-image: url(/images/btn-right-arrow.svg);
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
    border-radius: 3px;
    &:hover {
      background-color: ${colors.brand2Light};
      color: ${colors.body};
    }
  }
`);



// WEBPACK FOOTER //
// ./src/styles/reset.js